import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useFormikContext, useField } from 'formik';
import { pathOr, pipe, pathEq, not } from 'ramda';
import PropTypes from 'prop-types';

import { FIRST_NAME, LAST_NAME, usePatient, GENDER } from 'store/patients';
import { PROCEDURE, COMMENT, VALUE, PROCEDURE_STATUS, CODES } from 'store/diagnoses';
import { SALUTATION } from 'utils/constants';

import { Btn } from './styles';

const Button = ({ code, title, text, procedureValue }) => {
  const { id } = useParams();
  const [firstName, lastName, gender] = usePatient(id, [FIRST_NAME, LAST_NAME, GENDER]);
  const { setValues } = useFormikContext();
  const [{ value: currentCodes }] = useField(`${PROCEDURE}.${CODES}`);
  const patientName = useMemo(() => {
    if (!firstName || !lastName) return 'die Patientin / den Patienten';
    return `${SALUTATION[gender] ? `${SALUTATION[gender]} ` : ''}${firstName} ${lastName}`;
  }, [firstName, lastName, gender]);
  const handleClick = useCallback(() => {
    setValues(($) => {
      const codes = pathOr([], [PROCEDURE, CODES], $);
      const prevComment = pathOr('', [PROCEDURE, COMMENT], $).trim();
      const comment = text.replace(/%PATIENT%/g, patientName);

      return {
        ...$,
        [PROCEDURE]: {
          ...$[PROCEDURE],
          ...(!prevComment.includes(comment) && { [COMMENT]: [prevComment, comment].filter(Boolean).join(' ') }),
          ...(pipe(pathEq(PROCEDURE_STATUS.NO_TREATMENT, [PROCEDURE, VALUE]), not)($) && { [VALUE]: procedureValue }),
          ...(!codes.includes(code) && { [CODES]: [...codes, code] }),
        },
      };
    });
  }, [code, patientName, procedureValue, setValues, text]);

  return (
    <Btn type="button" onClick={handleClick} isActive={currentCodes?.includes(code)}>
      {title}
    </Btn>
  );
};

Button.propTypes = {
  code: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  procedureValue: PropTypes.number.isRequired,
};

export default Button;
